// Registers the Bookforge service worker for PWA install / offline support.
export function registerServiceWorker() {
  if (
    process.env.NODE_ENV === "production" &&
    typeof window !== "undefined" &&
    "serviceWorker" in navigator
  ) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .catch(() => {
          /* ignored — PWA features will simply be unavailable */
        });
    });
  }
}
